module.exports = __webpack_public_path__ + "img/icon_choix_metiers.8bb5abca.svg";